import React, { Component } from 'react';
import AiImageBigWrap from './AiImageBigWrap';
import Sticky  from "react-sticky-el";
import {OPTION_URL} from '../constants';
//import AiAppointment from './AiAppointment';

//import {Button} from 'primereact/components/button/Button';

class LeftPanel extends Component { 
    render() {
   
    return (<div className='ai-left-panel' >
    <Sticky className="ai-sticky-left" topOffset={0}>  
    <div className='ai-cfg'>{this.props.cfg}</div>
    <div className='ai-title'>{this.props.title}</div>
    <i className='ai-startover'
        onClick={this.props.onStartOver}>
        <img className="ai-startover-button" 
        src={OPTION_URL + "small/button/so3.png"} alt=""
        srcSet={OPTION_URL + "small/button/so3.png 1x, " +OPTION_URL + "large/button/so3.png 2x"}
        />
        </i>
        <i className='ai-zoom' >
        <img className="ai-zoom-button" 
        src={OPTION_URL + "small/button/z3.png"} 
        srcSet={OPTION_URL + "small/button/z3.png 1x, " +OPTION_URL + "large/button/z3.png 2x"}
        onClick={this.props.onPushOpenBox}
        alt=""/>
        </i> 
    <AiImageBigWrap size={this.props.size}  orientation={this.props.orientation}/> 
   
    </Sticky> 
    
      </div>
        );
    }
}



export default LeftPanel;


// WEBPACK FOOTER //
// ./src/layout/LeftPanel.js